/**
 * 2019.1.22 by lyf
 *
 * @param {Object} shopStatus
 * @example { status: 1, type: 1 } status=0 单门店 | status=1 多门店，type=1 总部，type=2 子店
 * @returns {Number} 'single': 单门店，'main': 多门店-总部，'sub': 多门店-子店
 */
const getShopType = (shopStatus) => {
  // 多门店
  if (typeof shopStatus === 'object' && shopStatus !== null && shopStatus.status === 1) {
    if (shopStatus.type === 1) return 'main'; // 多门店-总部
    if (shopStatus.type === 2) return 'sub'; // 多门店-子店
  }
  // 单门店
  return 'single';
};

export default getShopType;
